import { render, staticRenderFns } from "./ReportAssessment.vue?vue&type=template&id=0efe8e6c&scoped=true&"
import script from "./ReportAssessment.vue?vue&type=script&lang=js&"
export * from "./ReportAssessment.vue?vue&type=script&lang=js&"
import style0 from "./ReportAssessment.vue?vue&type=style&index=0&id=0efe8e6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efe8e6c",
  null
  
)

export default component.exports